import hasInsurances, {IHasInsurances} from "@/model/mixins/Insurance/hasInsurances"
import hasInsurancesSelected, {IHasInsurancesSelected} from "@/model/mixins/Insurance/hasInsurancesSelected"
import hasInsurancesIncluded, {IHasInsurancesIncluded} from "@/model/mixins/Insurance/hasInsurancesIncluded"
import hasInsuranceFamilyContent, {IHasInsuranceFamilyContent} from "@/model/mixins/Content/hasInsuranceFamilyContent"

class InsuranceFamilyBase {
    private id: string

    constructor(
        id: string,
    ) {
        this.id = id
    }

    public getId(): string {
        return this.id
    }

}

export interface IInsuranceFamily extends InsuranceFamilyBase, IHasInsurancesIncluded, IHasInsurances, IHasInsurancesSelected, IHasInsuranceFamilyContent {
    getId(): string
}

// apply mixin
const InsuranceFamily: Constructor<IInsuranceFamily> = hasInsurancesIncluded(hasInsuranceFamilyContent(hasInsurancesSelected(hasInsurances(InsuranceFamilyBase))))

export default InsuranceFamily